import { DestroyRef, Injectable } from '@angular/core';
import { API, ColorDefinitionDTO } from './api/api';
import { ErrorService } from './error.service';
import { UtilService } from './util.service';
import { RoutingID } from '../routes/sb-routing-enum';
import { NavigationService } from '@ngx-seatback/utils';
import { PermissionService } from './permission.service';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class ColorPickerService {
  colorDefSet: ColorDefinitionDTO[];
  colorDef: string[];

  constructor(
    private api: API,
    private errorHandler: ErrorService,
    public util: UtilService,
    private navService: NavigationService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.colorDef = [];
  }

  setColor(colorSet: string[]) {
    if (this.permissionService.hasPermission(this.permissionService.Permission.color_definition_create)) {
      let singleColor = colorSet[colorSet.length - 1];
      singleColor = this.util.convertRGBtoHex(singleColor);
      const colorDef: ColorDefinitionDTO = new ColorDefinitionDTO();
      colorDef.name = 'Default';
      colorDef.color = singleColor;
      this.api
        .shared_ColorDefinition_createColorDefinition(colorDef)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: color => {
            if (color) {
              this.colorDef.push(color.color);
              this.navService.resolvePoint(RoutingID.colorEdit, [{ id: 'colorID', value: color?.id }]).then(link => {
                window.open('https://' + window.location.host + link, '_blank');
              });
            }
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  deleteColor(colorDef: ColorDefinitionDTO) {
    if (this.permissionService.hasPermission(this.permissionService.Permission.color_definition_delete)) {
      this.api
        .shared_ColorDefinition_deleteColorDefinition(colorDef.id)
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: () => {},
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  getColorSet() {
    if (this.permissionService.hasPermission(this.permissionService.Permission.color_definition_list)) {
      this.colorDef = [];
      this.colorDefSet = [];
      this.api
        .shared_ColorDefinition_getColorDefinitions()
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: data => {
            this.colorDefSet = data;
            if (this.colorDefSet && this.colorDefSet.length > 0) {
              for (const def of this.colorDefSet) {
                if (this.colorDef.length < 8) {
                  this.colorDef.push('#' + def.color);
                }
              }
            }
          },
        });
    }
  }
}
